define('ctrl/web-view/article-details',['require','ns','ctrl/base'],function (require) {
	'use strict';

	var ns = require('ns');

	var BaseController = require('ctrl/base');

	var _selector = {
		articleMainContent: '.article-main-content',
		articleImageWrapper: '.article-image-wrapper',
		articleVideoWrapper: '.article-video-wrapper',
		onetvImage: '.onetv-image',
		onetvVideo: '.onetv-video',
		relatedContentWrapper: '.related-content-wrapper',
		relatedContentBody: '.related-content-body',
		thumb: '.thumb',
		previewBar: '.preview-bar',
		previewBtn: '#preview-btn',
		previewDevice: '#preview-device',		
		previewLocale: '#preview-locale-code',

		albumImage: '.album-image',
		albumPrevious: '.album-previous',		
		albumNext: '.album-next',
		albumPage: '.album-page',
		albumTotal: '.album-total',
                
                watchBtn: ".watch-btn",
                learnMoreBtn: ".learn-more-btn",
        
                internalVideoSection: 'internal-video-section', // Embedded content button
        		callToActionBtn: "call-to-action-section" // Call to action button
	};

	var $selector = {};

	var deviceMap = {
		'Nexus 5X': {
			width: 411,
			height: 731
		},
		'Nexus 6P': {
			width: 435,
			height: 733
		},
		'iPhone 5': {
			width: 320,
			height: 568
		},
		'iPhone 6': {
			width: 375,
			height: 667
		},
		'iPhone 6 Plus': {
			width: 414,
			height: 736
		},
		'iPad': {
			width: 768,
			height: 1024
		}
	};

	var localeCodeList = [
		'zh-hk',
		'en-us'
	];

	var _localeCode = null;

	var WebViewArticleDetailController = BaseController.extend({
		
	_getContentImageArticleImageSizeId: function (imageList) {
			
            var deviceWidth = ns.utils.getDeviceWidth();
            var bestSizeId = 0;
            var bestWidthDiff = 0;
            for (var sizeId in imageList){
                var imageDetails = imageList[sizeId];
                var widthDiff = Math.abs(deviceWidth - imageDetails["width"]);
                if (bestSizeId === 0 || widthDiff < bestWidthDiff){
                    bestSizeId = sizeId;
                    bestWidthDiff = widthDiff;
                }
            }
            return bestSizeId;
	},

        _getContentImagePosterSizeId: function () {
            var deviceWidth = ns.utils.getDeviceWidth();
            
            if (deviceWidth <= 480) {
                return ns.constant.get('POSTER_SIZE:SMALL');
            } else if (deviceWidth > 480 && deviceWidth <= 768) {
                return ns.constant.get('POSTER_SIZE:MEDIUM');
            }

            return ns.constant.get('POSTER_SIZE:LARGE');
        },
		
	_reformArticleContent: function (imageResourceList) {
			
			
			var that = this;
			var _reformArticleImage = function () {
				
				$selector.onetvImage.each(function () {
					
					var parentImageId = $(this).data('parent-image-id');
					
					var _availableList = imageResourceList[parentImageId] || {};
                                        var sizeId = that._getContentImageArticleImageSizeId(_availableList);
					
					if (!_.isEmpty(_availableList)) {
                                            var _key = Object.keys(_availableList).filter(function(key) {
                                                return _availableList[key]['size'] == sizeId;
                                            })[0] || 0;
                                            var _resource = _availableList[_key] || {};
						
                                            var template = _.template($('#article-image-tmpl').html());
						
                                            $(this).replaceWith(template(_resource));
					}
					
				});
			};
			
			var _reformArticleVideo = function () {
				
				$selector.onetvVideo.each(function () {
					
					var $videoWrapper = $('<div/>', {
						'class': _selector.articleVideoWrapper.substring(1)
					});
					
					$(this)
						.unwrap()
						.wrap($videoWrapper);
				});
			};
			
			_reformArticleImage();
			_reformArticleVideo();
			
			$selector.articleMainContent.addClass('is-loaded');
	},

		_registerEvent: function () {
			
			var that = this;

			$selector.previewBtn.on('click', function() {
				
				var device = $selector.previewDevice.val();
				var localeCode = $selector.previewLocale.val();

				that._resizeViewPort(deviceMap[device].width, deviceMap[device].height);

				if (_localeCode !== localeCode) {
					var url = window.location.href;
					url = url.replace(_localeCode, localeCode);
					window.location = url;
				}
			});

			$(window).resize($.proxy(function () {
				
				this.renderRelatedContent();
				
			}, this));
                        
                        /*
						/* Click Watch button tracking
						/* Category: External Program Detail
						/* Action: Click Watch Button
						/* Label: [ExtProgId] - [ProgramTitle]
						 */
						$selector.watchBtn.on('click', function(){
							that._registerGATrackingEvent($(this).data("content-id") + " - " + $(this).data("title"), 'External Program Detail', 'Click Watch Button');
						});

						/*
						/* Click Learn More button tracking
						/* Category: External Program Detail
						/* Action: Click Learn More Button
						/* Label: [ExtProgId] - [ProgramTitle]
						 */
						$selector.learnMoreBtn.on('click', function(){
							that._registerGATrackingEvent($(this).data("content-id") + " - " + $(this).data("title"), 'External Program Detail', 'Click Learn More Button');
						});

                        /*
                        /* Embedded content tracking
                        /* Category: Article
                        /* Action: Click Embedded Content
                        /* Label: [Article Id] - [Content Id]
                         */
						$selector.internalVideoSection.on('click', function(){
                            that._registerGATrackingEvent($(".article-main-content").data("article-id") + " - " + $(this).data("content-id"), 'Article', 'Click Embedded Content');
						});

                        /*
                        /* Call to action tracking
                        /* Category: Article
                        /* Action: Click Call-To-Action Button
                        /* Label: [Article Id] - [External URL]
                         */
						$selector.callToActionBtn.on('click', function(){
                            that._registerGATrackingEvent($(".article-main-content").data("article-id") + " - " + $(".redirect-url", this).attr("href"), 'Article', 'Click Call-To-Action Button');
						});

			this._registerAlbumnEvent();
		},

        /*
		/* Trigger GA tracking
		 */
        _registerGATrackingEvent: function (label, category, action) {

            ns.mapi.trackEvent({
                "category": category,
                "action": action,
                "label": label
            });

        },

		_registerAlbumnEvent: function () {

			this._deregisterAlbumnEvent();

			$selector.albumPrevious.on('click', $.proxy(this.previous, this));
			$selector.albumNext.on('click', $.proxy(this.next, this));

		},

		_deregisterAlbumnEvent: function () {

			$selector.albumPrevious.off();
			$selector.albumNext.off()

		},

		_resizeViewPort: function (width, height) {
			window.resizeTo(
				width + (window.outerWidth - document.documentElement.clientWidth),
				height + (window.outerHeight - document.documentElement.clientHeight) + $selector.previewBar.outerHeight()
			);
		},	
        
        _renderInternalVideoSection: function(response) {
            var sizeId = this._getContentImagePosterSizeId();
            
            $selector.internalVideoSection.each(function () {
                var contentId = $(this).data('content-id');
                var info = response[contentId] || {};
                if (_.isEmpty(info)) {
                    return;
                }
                
                var _availableList = info['image_dimensions'] || [];
                var _resource = _availableList.filter(function(image) {
                    return image['size'] == sizeId;
                })[0] || {};

                // 
                var contentClass = 'play';
                var badgeMsg = '';
                switch(info['content_tier_id']) {
                	case ns.constant.get('CONTENT_TIER:FREE_FOR_ALL'):
                		break;
                	case ns.constant.get('CONTENT_TIER:FREE_FOR_MEMBER'):
                		contentClass = 'free-for-member';
                		badgeMsg = ns.i18n.get('freeForMemberBadge');
                		break;
                	case ns.constant.get('CONTENT_TIER:PREMIUM'):
                		contentClass = 'premium';
                		badgeMsg = ns.i18n.get('skymateBadge');
                		break;
                	case ns.constant.get('CONTENT_TIER:SKYPLUS'):
                		contentClass = 'skyplus';
                		badgeMsg = ns.i18n.get('skyplusBadge');
                		break;
                	default:
                		break;
                }
                if (info['content_type'] == ns.constant.get('CONTENT_TYPE:CHANNEL')) {
                	if (info['channel_type'] == ns.constant.get('CHANNEL_TYPE:LIVE')) {
            			contentClass = 'live';
            			badgeMsg = ns.i18n.get('live');

            			if (info['live_status'] == ns.constant.get('LIVE_STATUS:PENDING')) {
            				contentClass += ' pending';
            				badgeMsg = ns.i18n.get('livePending');
            			}
            			else if (info['live_status'] == ns.constant.get('LIVE_STATUS:OFF_AIR')) {
            				contentClass += ' off-air';
            			}
            			else {
            				contentClass += ' on-air';
            			}
            		}
                }

                var duration = info['duration'];
                var hour = Math.floor(duration / 3600);
                var minute = Math.floor((duration - hour * 3600) / 60);
                var second = duration - hour * 3600 - minute * 60;
                duration = (hour ? hour + ':' : '') + (minute >= 10 ? minute + ':' : '0' + minute + ':') + (second >= 10 ? second : '0' + second);

                var deeplink = info['deep_link'] || '';
                if (info['status'] != ns.constant.get('CONTENT_STATUS:ON_SHELF')) {
                	contentClass = "off-shelf";
                	deeplink = null;
                }
                
                var param = {
                    content_id: contentId,
                    title: info['title'],
                    deep_link: deeplink,
                    poster_url: _resource['link'] || '',
                    btn_label: info['btn_label'],
                    off_shelf_label: info['off_shelf_label'],
                    content_class: contentClass,
                    duration: duration,
                    badge_msg: badgeMsg
                };
                
                var template = _.template($("#internal-video-section-tmpl").html());
                $(this).append(template(param));
            });
        },

		init: function () {

			BaseController.prototype.init.call(this);

			$selector = ns.utils.generateSelector(_selector);
			
			this._registerEvent();

			_localeCode = this.getUriSegment(0);

			var matched = location.pathname.match(/\/(.*)\/([0-9]*)/i);

			var param = {
				contentId: matched[2] || 0
			};
			
			var successCallback = $.proxy(function (response) {
				
				this._reformArticleContent(response);
				
			}, this);
			ns.api.content.getImageResources(param, successCallback);
                        
            
            // Internal video section
            var content_ids = [];
            $(_selector.internalVideoSection).each(function () {
                content_ids.push(parseInt($(this).attr("data-content-id")));
            });
            content_ids = content_ids.filter(function(item, idx) {
               return content_ids.indexOf(item) === idx;
            });
            param = {
                content_ids: content_ids,
//                locale_code: $("html").attr("lang")
                locale_code: "zh-hk" // always zh-hk, cause article content has zh-hk only
            };
            var internalVideoSectionSuccessCallback = $.proxy(function(response) {
                this._renderInternalVideoSection(response);
            }, this);
            ns.api.content.getEmbedSectionContentInfoList(param, internalVideoSectionSuccessCallback);
			
			this.renderRelatedContent();
			this.updateControl();

			if (!_.isUndefined($selector.previewDevice))
				this.renderPreviewOptions();
		},

		getUriSegment: function (i) {
			var segment =  window.location.pathname.substring(1).split('/');
			return segment[i];
		},
				
		renderRelatedContent: function () {
			
			$selector.relatedContentWrapper.each(function () {
				
				var _$relatedContentBody = $(this).find(_selector.relatedContentBody);
				var _$thumbList = $(this).find(_selector.thumb);
				
				var totalThumb = _$thumbList.length;
				var loadedThumb = 0;
				
				_$thumbList.each(function () {
					
					ns.loader.loadImgBySrcset($(this), function () {
						
						loadedThumb += 1;
						
						if (totalThumb === loadedThumb) {
							
							_$relatedContentBody.addClass('is-loaded');
						}
					});
				});
			});
		},

		renderPreviewOptions: function() {

			for (var device in deviceMap) {
				var $option = $('<option />', {
					value: device,
					text: device
				});

				$selector.previewDevice.append($option);
			}


			for (var i in localeCodeList) {
				var localeCode = localeCodeList[i];				
				var $option = $('<option />', {
					value: localeCode,
					text: localeCode
				});

				if (localeCode === _localeCode) {
					$option.attr('selected', 'selected');
				}

				$selector.previewLocale.append($option);
			}
		},

		next: function () {

			var $active = $('.album-image.active');
			var $next = $active.next().length > 0 ? $active.next() : $selector.albumImage.first();

			$selector.albumImage.removeClass('ctol ctor ltoc rtoc');
			$active.removeClass('active').addClass('ctol');
			$next.addClass('active rtoc');

			this.updateControl();
		},

		previous: function () {

			var $active = $('.album-image.active');
			var $previous = $active.prev().length > 0 ? $active.prev() : $selector.albumImage.last();

			$selector.albumImage.removeClass('ctol ctor ltoc rtoc');
			$active.removeClass('active').addClass('ctor');
			$previous.addClass('active ltoc');

			this.updateControl();
		},

		updateControl: function () {

			var $active = $('.album-image.active');
			var total = $selector.albumImage.length;
			var page = $selector.albumImage.index($active) + 1;

			$selector.albumPage.text(page);
			$selector.albumTotal.text(total);

			if (total > 1) {
				$selector.albumPrevious.addClass('active');
				$selector.albumNext.addClass('active');
				this._registerAlbumnEvent();		
			} else {
				$selector.albumPrevious.removeClass('active');
				$selector.albumNext.removeClass('active');				
				this._deregisterAlbumnEvent();
			}
		}
	});

	return WebViewArticleDetailController;
});
